import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MarkdownService } from '@app/markdown/services/markdown.service';
import { JobRole } from '@app/onboarding/services/onboarding.service';

@Component({
  selector: 'dgx-role-tile',
  templateUrl: './role-tile.component.html',
  styleUrls: ['./role-tile.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RoleTileComponent implements OnInit {
  @Input() public item: JobRole;

  public description: string = undefined;

  constructor(private markdownService: MarkdownService) {}

  public ngOnInit(): void {
    if (this.item?.description) {
      this.description = this.markdownService.markdownToPlaintext(
        this.item.description
      );
    }
  }
}
